import React from 'react';
import PropTypes from 'prop-types';
import ReSignContact from './ReSignContact';
import './ReSign.scss';

const ReSignSuccess = (props) => {
  const { contractEndDate } = props.info;
  return (
    <div>
      <h2>Great to have you on board.</h2>
      <div>
        Thanks for confirming your details, your new contract and free two months will start
        on: <strong>{contractEndDate}</strong>.
      </div>
      <div>
        We&apos;ll be in touch to confirm the details, so just sit tight and look out for our owl to deliver the
        message (kidding sorry, we&apos;ll actually send you an email).
      </div>
      <div>
        If you need to get in contact with us in the meantime, you can do so via one of the options below:
      </div>
      <ReSignContact />
    </div>
  );
};

ReSignSuccess.propTypes = {
  info: PropTypes.object.isRequired,
};

export default ReSignSuccess;



/** WEBPACK FOOTER **
 ** ./src/components/ReSign/ReSignSuccess.js
 **/